import styled from 'styled-components';
import { Icon } from '../icon';
import { chipConfig } from './utils';
export const ChipContainer = styled.div `
  // estilos generales
  width: 100%;
  max-width: max-content;
  padding: ${({ size }) => chipConfig.padding[size]} 8px;
  background-color: ${({ variant, color, skin, theme }) => {
    return variant === 'darken' && skin === 'outline'
        ? 'transparet'
        : chipConfig.skins[variant][color][skin].bg({ theme });
}};

  border: ${({ variant, color, skin, theme }) => {
    return '1px solid ' + chipConfig.skins[variant][color][skin].border({ theme });
}};

  border-radius: ${({ size }) => (size === 'small' ? '4px' : '8px')};

  // alineacion del contenido
  display: flex;
  align-items: center;
`;
export const Message = styled.span `
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  max-width: calc(224px - (${({ size }) => chipConfig.padding[size]} * 2));
  color: ${({ variant, color, skin, theme }) => {
    return variant === 'darken' && skin === 'fill'
        ? '#FFFF'
        : chipConfig.skins[variant][color][skin].textColor({ theme });
}};

  // ellipsis
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
`;
export const CustomIcon = styled(Icon) `
  margin-right: 4px;
`;
